import { render, staticRenderFns } from "./changeTat.vue?vue&type=template&id=4ae5ad1f"
import script from "./changeTat.vue?vue&type=script&lang=js"
export * from "./changeTat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports